import "../../assets/css/rotate.css";

import React, { Fragment } from "react";

const LoadingSpinner = () => {
    return (
        <Fragment>
            <div className="post-thumb h-100 d-flex justify-content-center align-items-center">
                <div className="col-lg-6 col-md-6 m-5">
                    <span className="card">
                        <div className="body text-center">
                            <img src={require('../../assets/images/havayar/HyMiniLogo.png')} alt="Havayar" className="rotate" />
                        </div>
                        <div className="card-footer text-center">
                            <h6 className="mt-3">در حال دریافت اطلاعات</h6>
                        </div>
                    </span>
                </div>
            </div>
        </Fragment>
    );
};
export default LoadingSpinner;
